const sliceUnicode = (s: string, start: number, end?: number) => [...s].slice(start, end).join('');

const lengthUnicode = (s: string) => [...s].length;

export {sliceUnicode, lengthUnicode};
